import React from "react";
import {NavigateFunction} from "react-router-dom";

// handle a click on an elevation icon-link: navigate to the tool on the current page. A
// ctrl/cmd/shift-click is left to the browser so it can still open the href in a new tab.
export function openElevation(e: React.MouseEvent, nav: NavigateFunction, url: string) {
    e.stopPropagation();
    if(e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    nav(url);
}

// the elevation tool url for an opening's hardware workspace, in production or quote mode.
export function hardwareElevationToolUrl(props: {
    project: number;
    opening: number;
    alternative?: number;
}) {
    if(props.alternative !== undefined) {
        return `/project/${props.project}/quote/${props.alternative}/elevation-tool?quoteOpening=${props.opening}&alternative=${props.alternative}&workspace=hardware`;
    }

    return `/project/${props.project}/shop-drawing/elevation-tool?opening=${props.opening}&workspace=hardware`;
}
